import { render, staticRenderFns } from "./ThePartners.vue?vue&type=template&id=2bcc089c&scoped=true"
import script from "./ThePartners.vue?vue&type=script&lang=js"
export * from "./ThePartners.vue?vue&type=script&lang=js"
import style0 from "./ThePartners.vue?vue&type=style&index=0&id=2bcc089c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc089c",
  null
  
)

export default component.exports